import { useEffect, useState } from "react";
import { TimeBankCard } from "../TimeBankCard";
import { C } from "../../lib/api";

// Rail button just to the right of the viewer's avatar: play a time bank card (+1 full clock). It covers all three
// clocks that can run out on you — your bet, your draw in a draw game, and your discard in Pineapple — and only
// appears once half of that clock has run down.
export const TimeBankButton = ({ my, legal, hand, serverNow, onTimebank, size = 105, side = "right" }) => {
  const [, tick] = useState(0);
  useEffect(() => { const id = setInterval(() => tick((n) => n + 1), 500); return () => clearInterval(id); }, []);
  if (!my || !(my.timebank > 0) || !hand) return null;
  const now = serverNow ? serverNow() : Date.now();
  const drawing = hand.draw?.pending?.includes(my.index) && hand.draw?.deadline;
  const discarding = hand.discard?.pending?.includes(my.index) && hand.discard?.deadline;
  const clock = drawing ? { deadline: hand.draw.deadline, total: C.TDA.DRAW_MS }
    : discarding ? { deadline: hand.discard.deadline, total: C.TDA.DISCARD_MS }
      : legal && hand.act_deadline ? { deadline: hand.act_deadline, total: hand.action_timeout_ms || 15000 } : null;
  if (!clock || clock.deadline - now > clock.total / 2) return null;
  const left = side === "left"; // same spot as the Show Cards buttons (they never show at the same time)
  // hugs the avatar like the plates: slides 30px under the circle, a radial mask cuts the avatar's curve out of it
  const mask = `radial-gradient(circle at ${left ? "calc(100% + 22.5px)" : "-22.5px"} ${size / 2 - size * 0.22}px, transparent ${size / 2 + 8}px, #000 ${size / 2 + 9}px)`;
  return (
    <button data-testid="action-timebank" onClick={onTimebank}
      title={drawing ? "Play a time bank card: more time to pick the cards you're throwing away" : "Play a time bank card: adds a full clock to your time left"}
      className={`absolute rounded-2xl border border-cyan-300/50 bg-cyan-600/80 hover:bg-cyan-500/90 text-cyan-50 text-[11px] font-display tracking-wider py-2 flex items-center gap-1.5 btn-lift rise z-20 whitespace-nowrap shadow-lg ${left ? "pl-3 pr-11" : "pl-11 pr-3"}`}
      style={{ top: size * 0.22, minWidth: 152, ...(left ? { right: size - 30 } : { left: size - 30 }), WebkitMaskImage: mask, maskImage: mask }}>
      <TimeBankCard h={15} /> TIME BANK <span className="font-mono text-cyan-200">×{my.timebank}</span>
    </button>
  );
};
